export const getRedirectUrl = (
  mainRoutes: string,
  location: any,
  otherParams?: string,
) => {
  let redirectUrl = `/${mainRoutes}`;
  if (location?.search) {
    redirectUrl += `${location.search}&`;
  } else {
    redirectUrl += `?`;
  }
  redirectUrl += `signed_in=true`;
  if (otherParams) {
    redirectUrl += `&${otherParams}`;
  }
  return redirectUrl;
};
